// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_adc","cls2":"SimplePaperPodcast-cls2_XsR SimplePaperPodcast-cls1_adc"};